export function sanitizeIntegerInput(value) {
    const [intPart] = String(value).split('.');
    return intPart.replace(/[^0-9]/g, '');
}

export function formatMXN(value) {
    const amount = Math.round(Number(value) || 0);
    return `$${amount.toLocaleString('es-MX')} mxn`;
}
